import { render, staticRenderFns } from "./solicitar_servicoEdit.vue?vue&type=template&id=71d52a11&scoped=true&"
import script from "./solicitar_servicoEdit.vue?vue&type=script&lang=js&"
export * from "./solicitar_servicoEdit.vue?vue&type=script&lang=js&"
import style0 from "./solicitar_servicoEdit.vue?vue&type=style&index=0&id=71d52a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d52a11",
  null
  
)

export default component.exports